module.exports = __webpack_public_path__ + "static/media/pochette-40x40.a4956b46.jpg";